import { useEffect, useState } from 'react'
import * as S from './styles'
import moment, { Moment } from 'moment'
import { useLocation } from 'react-router-dom'
import { usePaymentProvider } from 'context/paymentContext'
import { useAnyProvider } from 'hooks/Context'
import dayjs from 'dayjs'
import { useSessionStorage } from 'context/sessionStorage'
import { useDateDifference } from 'hooks/useDateDifference'
import Skeleton from "react-loading-skeleton"


export type ReserveDetails = {
    address: {
        city: string,
        area: string,
        stateCode: string,
        street: string,
    },
    id: string,
    accommodationName: string,
    mainImage: string,
    checkIn?: string,
    checkOut?: string,
}

interface CustomStayCardProps {
    cardBottom?: boolean;
    onClick: () => void;
    onClickCupom: () => void;
    discount?: boolean;
    accommodation: ReserveDetails
}

export const PaymentCard = ({ onClick, onClickCupom, discount, accommodation, }: CustomStayCardProps) => {

    const { saveToSessionStorage, getFromSessionStorage } = useSessionStorage()

    const subtractDates = (date1: dayjs.Dayjs, date2: dayjs.Dayjs): number => {
        if (!date1 || !date2) return 0;
        return date1.diff(date2, 'day');
    };
    const [details, setDetails] = useState<any>()
    const [newDifference, setNewDifference] = useState<any>()

    const location = useLocation()

    const validationCupom = location.pathname === '/payment' ? true : false

    const { expensesValues, totalValue, reserveDetails } = usePaymentProvider()
    const { date } = useAnyProvider()

    const { accommodationName, address, mainImage, checkIn, checkOut } = accommodation ?? reserveDetails

    const difference = date ? subtractDates(date[1], date[0]) : 0;

    const discountDifference = (expensesValues.definedDailyValue * difference) - (expensesValues.definedDailyValue * difference * 0.1)

    const discountValue = (expensesValues.definedDailyValue * difference * 0.1)

    const { weeklyDifference: weekValue } = useDateDifference(date)

    const warningSimbol = require('../../assets/svg/WarningCircle.svg').default;
    // const cupomIcon = require('../../assets/svg/Cupom.svg').default;


    const getCheckOut = (date: any) => {
        if (date?.[1] === undefined || date?.[1] === null) {
            return dayjs(checkOut).format('DD/MM/YYYY');
        }
        return date?.[1] ? date[1].format('DD/MM/YYYY') : null;
    };

    const getCheckIn = (date: any) => {
        if (date?.[0] === undefined || date?.[0] === null) {
            return dayjs(checkIn).format('DD/MM/YYYY');
        }
        return date?.[0] ? date[0].format('DD/MM/YYYY') : null;
    };
    useEffect(() => {
        const paymentDetails = getFromSessionStorage('payment');
        if (paymentDetails !== null) {
            setDetails(paymentDetails)
            setNewDifference(paymentDetails.difference)
        } else {
            setNewDifference(difference)
        }


    }, []);


    function formatarData(data: string) {
        const dataObj = new Date(data);
        const dia = dataObj.getDate().toString().padStart(2, '0');
        const mes = (dataObj.getMonth() + 1).toString().padStart(2, '0'); // Mês começa do 0
        const ano = dataObj.getFullYear().toString();
        return `${dia}/${mes}/${ano}`;
    }
    return (
        <S.Container>
           
             <S.TitlePayment>Conclua sua reserva</S.TitlePayment>
            <S.TitleCard>Resumo da sua hospedagem</S.TitleCard>
            <S.Header>
                <S.ImageAccommodation>
                    <img src={mainImage === '' ? details?.mainImage : mainImage} alt="" />
                </S.ImageAccommodation>
                <S.AccommodationInfo>
                    <S.Subtitle>{accommodationName === '' ? details?.accommodationName : accommodationName}</S.Subtitle>
                    <p>{address.street === '' ? details?.address?.street : address.street} -{address.city === '' ? details?.address?.city : address.city}, {address.stateCode === '' ? details?.address?.stateCode : address.street}</p>
                    <S.LabelContainer>
                        <div>
                            <span>Entrada </span>
                            <p>{getCheckIn(date) === 'Invalid Date' ? formatarData(details?.checkIn) : getCheckIn(date)}</p>
                        </div>
                        <div>
                            <span>Saída </span>
                            <p><p>{getCheckOut(date) === 'Invalid Date' ? formatarData(details?.checkOut) : getCheckOut(date)}</p></p>
                        </div>

                    </S.LabelContainer>
                </S.AccommodationInfo>
            </S.Header>
            <S.Content>
                {newDifference >= 27 && <S.PaymentContainer>
                    <S.Rows discount={discount}>
                        <p>Aluguel</p>
                        <S.ContainerValues discount={discount}>
                            {discount && <span>De</span>}
                            <label>R$</label>
                            <S.RowValues discount={discount}>
                                {newDifference >= 27 ? details?.valueMidStay : expensesValues.definedDailyValue.toFixed(0)}
                            </S.RowValues>
                        </S.ContainerValues>
                        {discount && <S.ContainerValues >
                            <label>R$</label>
                            <S.RowValues>
                                {discountDifference.toFixed(0)},00
                            </S.RowValues>
                        </S.ContainerValues>}
                        {discount && <S.Discount>
                            Você economiza R$ {discountValue.toFixed(0)},00(10%)
                        </S.Discount>}
                    </S.Rows>
                    <S.Rows>
                        <p>Condomínio</p>
                        <S.ContainerValues>
                            <label>R$</label>
                            <S.RowValues>
                                {details?.valorCondominio}
                            </S.RowValues>
                        </S.ContainerValues>
                    </S.Rows>
                    <S.Rows>
                        <p>IPTU</p>
                        <S.ContainerValues>
                            <label>R$</label>
                            <S.RowValues>
                                {details?.iptu}</S.RowValues>
                        </S.ContainerValues>
                    </S.Rows>
                    <S.Rows>
                        <p> {details?.weekValue} Limpezas</p>
                        <S.ContainerValues>
                            <label>R$</label>
                            <S.RowValues>
                                {newDifference >= 27 && details?.valorLimpeza}</S.RowValues>
                        </S.ContainerValues>
                    </S.Rows>
                    <S.Rows>
                        <p>Pacote Yogha</p>
                        <S.ContainerValues>
                            <label>R$</label>
                            <S.RowValues>
                                {details?.pacoteYogha}</S.RowValues>
                        </S.ContainerValues>
                    </S.Rows>
                    <S.TotalRow>
                        <S.Total>Total</S.Total>
                        <S.ContainerValues>
                            <S.PrefixTotal>R$</S.PrefixTotal>
                            <S.TotalValue>
                                {details?.total},00
                            </S.TotalValue>
                        </S.ContainerValues>
                    </S.TotalRow>
                    {validationCupom && <S.FooterButtons>
                        <S.ContainerUndestandValues>
                            
                            {/* <S.CupomContainer onClick={onClickCupom}>
                                <img src={cupomIcon} alt="" /> <p>Possui algum cupom?</p>
                            </S.CupomContainer> */}
                        </S.ContainerUndestandValues>
                    </S.FooterButtons>}
                </S.PaymentContainer>
                }
                {newDifference < 27 && <S.PaymentContainer>
                    <S.Rows discount={discount}>
                        <p>{difference === 0 ? details?.difference : difference} Noites</p>
                        <S.ContainerValues discount={discount}>
                            {discount && <span>De</span>}
                            <label>R$</label>
                            <S.RowValues discount={discount}>
                                {expensesValues.definedDailyValue.toFixed(0) === '0' ? details?.valueN : `${expensesValues.definedDailyValue.toFixed(0)},00`}
                            </S.RowValues>
                        </S.ContainerValues>
                        {discount && <S.ContainerValues >
                            <label>R$</label>
                            <S.RowValues>
                                {discountDifference.toFixed(0)},00
                            </S.RowValues>
                        </S.ContainerValues>}
                        {discount && <S.Discount>
                            Você economiza R$ {discountValue.toFixed(0)},00(10%)
                        </S.Discount>}
                    </S.Rows>
                    <S.Rows>
                        <p>{weekValue === 0 ? details?.weekValue : weekValue} Limpeza{weekValue > 1 || details?.weekValue > 1 && 's'}</p>
                        <S.ContainerValues>
                            <label>R$</label>
                            <S.RowValues>
                                {weekValue !== 0 ? `${weekValue * expensesValues.cleaningValue},00` : details?.valueWe}
                            </S.RowValues>
                        </S.ContainerValues>
                    </S.Rows>
                    <S.Rows>
                        <p>Pacote Yogha</p>
                        <S.ContainerValues include>
                            <label>incluso</label>
                        </S.ContainerValues>
                    </S.Rows>
                    <S.TotalRow>
                        <S.Total>Total</S.Total>
                        <S.ContainerValues>
                            <S.PrefixTotal>R$</S.PrefixTotal>
                            <S.TotalValue>
                                {totalValue.toFixed(0) === '0' ? `${details?.total},00` : `${totalValue.toFixed(0)},00`}
                            </S.TotalValue>
                        </S.ContainerValues>
                    </S.TotalRow>
                    {validationCupom && <S.FooterButtons>
                        <S.ContainerUndestandValues>
                            
                            {/* <S.CupomContainer onClick={onClickCupom}>
                                <img src={cupomIcon} alt="" /> <p>Possui algum cupom?</p>
                            </S.CupomContainer> */}
                        </S.ContainerUndestandValues>
                    </S.FooterButtons>}
                </S.PaymentContainer>}
            </S.Content>
        </S.Container>
    )
}